<page-headline
    [module]="'performance'"
    [moduleIcon]="'fa-heartbeat'"
    [moduleLink]="'performance/insights/'"
    [pageTitle]="'KPIs for Each Employee'"
    [linkTitle]="'Performance Insights'"
>
</page-headline>
<div class="kpi-lo-insights-main-flter-n-search-area">
    <main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
    <div class="kpi-lo-insights-search-area">
        <search-dialog
            (searchOutput)="searchRows($event)"
            [searchId]="'kpi-lo-insights'"
            [searchBoxHeight]="44"
            [resetSearch]="false"
        >
        </search-dialog>
    </div>
</div>
<div class="kpi-lo-display-opt-n-lo-ddl-area">
    <div class="kpi-lo-ddl-area">
        <div class="kpi-items-ddl">
            <angular2-multiselect
                [data]="positions"
                *ngIf="roleName === 'Employee'"
                [(ngModel)]="selectedPosition"
                [settings]="kpiProfileSettings"
                (onSelect)="onSelectionChangeProfile($event)"
                (onDeSelect)="onDeSelectProfile($event)"
            >
            </angular2-multiselect>
        </div>
        <div class="kpi-items-ddl">
            <angular2-multiselect
                [data]="entityList"
                [(ngModel)]="selectedEntity"
                [settings]="entityListSettings"
                (onSelect)="onSelectionChange($event)"
                (onDeSelect)="onDeSelect($event)"
            >
            </angular2-multiselect>
        </div>
    </div>
    <div class="displayopt-layout">
        <display-options
            (displayOptionsOutput)="applyDisplayOptions($event)"
            [syncAsOfDateInf]="syncAsOfDateInf"
        >
        </display-options>
        <action-panel
            [showExportCsv]="false"
            [showSaveAsPdf]="true"
            [showPrint]="false"
            [title]="pageHeadline.pageTitle"
        >
        </action-panel>
    </div>
</div>
<common-kendo-table
    [tableColumnProperties]="tableColumnProperties"
    [tableDataProperties]="tableDataProperties"
    (pageChangeEvent)="gridChangeEvent($event)"
    class="kpi-sparkline-kendo"
>
</common-kendo-table>
